import base from './base';
import data from './data/point';

const pointApi = {};

pointApi.getPointInfo = () => {
  return base.fetch(data.point, 300);
};

pointApi.getPointHistory = (val) => {
  console.log(val);
  return base.fetch(data.pointHistory, 300);
};

export default {
  ...pointApi,
};
